/* ============================================================
   Lagomlo — contests.js (Shopify theme)
   Design contest page controller (port of preview/js/contests.js):
   list, detail, launch, enter, vote (1 per user per contest),
   leaderboard, and the bridge "make this entry a blanket".
   Data: localStorage 'lagomlo.contests' + 'lagomlo.aiDesign' bridge.

   Session: the contests.liquid section renders the customer email into
   [data-contests][data-contests-customer-email] ('' = guest). All dynamic
   strings come from the #contestsI18n JSON blob rendered by Liquid, so copy
   stays in the locale file.

   DEMO NOTE: contests live in localStorage only. A Shopify App / backend is
   required for shared, anti-abuse-safe contests (server-side votes/entries,
   IP/email limits, moderation) before going live.

   Exposed: window.Contests
   ============================================================ */
(function (global) {
  'use strict';

  var LS_KEY = 'lagomlo.contests';
  var DESIGN_BRIDGE = 'lagomlo.aiDesign';

  function el(id) { return document.getElementById(id); }

  function readLS(key, fallback) {
    try {
      var raw = global.localStorage.getItem(key);
      return raw === null ? fallback : JSON.parse(raw);
    } catch (e) { return fallback; }
  }
  function writeLS(key, value) {
    try { global.localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function escHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Toast (tiny dependency-free replacement for Store.toast) ---------- */
  function toast(message) {
    var box = document.querySelector('.lagomlo-toasts');
    if (!box) {
      box = document.createElement('div');
      box.className = 'lagomlo-toasts';
      document.body.appendChild(box);
    }
    var t = document.createElement('div');
    t.className = 'lagomlo-toast';
    t.textContent = message;
    box.appendChild(t);
    setTimeout(function () {
      t.classList.add('is-leaving');
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 300);
    }, 2600);
  }

  /* ---------- i18n (strings rendered by Liquid into #contestsI18n) ---------- */
  function i18n() {
    var node = el('contestsI18n');
    if (!node) return {};
    try { return JSON.parse(node.textContent) || {}; } catch (e) { return {}; }
  }

  function fmt(tpl, map) {
    var s = String(tpl == null ? '' : tpl);
    Object.keys(map || {}).forEach(function (k) {
      s = s.split('{{ ' + k + ' }}').join(String(map[k]));
    });
    return s;
  }

  function rootEl() { return document.querySelector('[data-contests]'); }

  function currentUser() {
    var root = rootEl();
    if (!root) return null;
    var email = (root.getAttribute('data-contests-customer-email') || '').trim();
    if (!email) return null;
    return { email: email, name: email.split('@')[0] || email };
  }

  function loginUrl() {
    var routes = (global.Lagomlo && global.Lagomlo.routes) || {};
    return (routes.root || '/') + 'account/login';
  }

  /* ---------- data ---------- */
  function contests() { return readLS(LS_KEY, []); }
  function save(list) { writeLS(LS_KEY, list); }

  function nextId(prefix) {
    var max = 1000;
    var list = prefix === 'ct' ? contests() : [];
    list.forEach(function (c) {
      (c.entries || []).forEach(function (en) {
        var m = /en_(\d+)/.exec(en.id || '');
        if (m) max = Math.max(max, parseInt(m[1], 10));
      });
    });
    if (prefix === 'ct') {
      contests().forEach(function (c) {
        var m = /ct_(\d+)/.exec(c.id || '');
        if (m) max = Math.max(max, parseInt(m[1], 10));
      });
    }
    return prefix + '_' + (max + 1);
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function timeLeft(deadline) {
    var t = i18n();
    var diff = new Date(deadline).getTime() - Date.now();
    if (diff <= 0) return t.closed || 'Closed';
    var days = Math.ceil(diff / 86400000);
    var tpl = days === 1 ? (t.time_left_one || '{{ count }} day left') : (t.time_left_other || '{{ count }} days left');
    return fmt(tpl, { count: days });
  }

  /* ---------- seed demo contests (first run only) ---------- */
  function seedIfEmpty() {
    if (contests().length > 0) return;
    var now = Date.now();
    var mk = function (offsetDays) { return new Date(now + offsetDays * 86400000).toISOString(); };
    var demo = [
      {
        id: 'ct_1001',
        title: 'Coziest Pet Blanket',
        description: 'Show us your furry friend in blanket form! Watercolor, cartoon or pixel — any style welcome. Winner gets a free 50×60 blanket.',
        prize: 'Free 50×60 blanket + homepage feature',
        deadline: mk(9),
        createdBy: 'lagomlo',
        createdAt: mk(-2),
        entries: [
          { id: 'en_1001', userId: 'demo@lagomlo.com', authorName: 'Ava', prompt: 'golden retriever, watercolor, soft pastels', imageDataUrl: null, votes: 128 },
          { id: 'en_1002', userId: 'demo@lagomlo.com', authorName: 'Leo', prompt: 'black cat, sticker style, kawaii', imageDataUrl: null, votes: 94 },
          { id: 'en_1003', userId: 'demo@lagomlo.com', authorName: 'Mia', prompt: 'corgi, pixel art, 8-bit', imageDataUrl: null, votes: 76 }
        ],
        votes: {}
      },
      {
        id: 'ct_1002',
        title: 'Dream Vacation Blanket',
        description: 'Your dream destination as a cozy blanket. Beaches, mountains, cities — paint the picture.',
        prize: 'Free 60×80 blanket + $50 credit',
        deadline: mk(16),
        createdBy: 'lagomlo',
        createdAt: mk(-5),
        entries: [
          { id: 'en_1004', userId: 'demo@lagomlo.com', authorName: 'Noah', prompt: 'tropical beach, vintage travel poster', imageDataUrl: null, votes: 87 },
          { id: 'en_1005', userId: 'demo@lagomlo.com', authorName: 'Emma', prompt: 'northern lights, minimal, night sky', imageDataUrl: null, votes: 141 }
        ],
        votes: {}
      }
    ];
    save(demo);
  }

  /* ---------- rendering ---------- */
  function renderList() {
    var grid = el('contestGrid');
    var t = i18n();
    if (!grid) return;
    var list = contests().slice().sort(function (a, b) { return new Date(b.createdAt) - new Date(a.createdAt); });
    if (!list.length) {
      grid.innerHTML = '<div class="contest-empty"><p>' + escHtml(t.empty_list || 'No contests yet \u2014 be the first to launch one!') + '</p></div>';
      return;
    }
    grid.innerHTML = list.map(function (c) {
      var entries = c.entries || [];
      var totalVotes = entries.reduce(function (s, e) { return s + (e.votes || 0); }, 0);
      var deadline = fmtDate(c.deadline);
      return (
        '<article class="card contest-card" data-contest="' + escHtml(c.id) + '">' +
        '  <div class="contest-card__head">' +
        '    <span class="badge">' + escHtml(timeLeft(c.deadline)) + '</span>' +
        '    <span class="contest-card__meta">' + escHtml(fmt(t.entries_count || '{{ count }} entries', { count: entries.length })) + ' \u00B7 ' + escHtml(fmt(t.votes_count || '{{ count }} votes', { count: totalVotes })) + '</span>' +
        '  </div>' +
        '  <h3 class="contest-card__title">' + escHtml(c.title) + '</h3>' +
        '  <p class="contest-card__desc">' + escHtml(c.description) + '</p>' +
        '  <div class="contest-card__foot">' +
        '    <span class="contest-card__prize">' + escHtml(fmt(t.prize_prefix || '\uD83C\uDF81 ', {}) + c.prize) + '</span>' +
        '    <span class="contest-card__deadline">' + escHtml(fmt(t.ends || 'Ends {{ date }}', { date: deadline })) + '</span>' +
        '  </div>' +
        '</article>'
      );
    }).join('');
    Array.prototype.forEach.call(grid.querySelectorAll('[data-contest]'), function (card) {
      card.addEventListener('click', function () { showDetail(card.getAttribute('data-contest')); });
    });
  }

  function placeholderFor(i) {
    var ph = global.LagomloPlaceholder;
    if (ph && typeof ph.dataUri === 'function') {
      try { return ph.dataUri('photo-blanket', 300, 300, i); } catch (e) { return ''; }
    }
    return '';
  }

  function renderDetail(id) {
    var c = contests().filter(function (x) { return x.id === id; })[0];
    var body = el('contestDetailBody');
    var t = i18n();
    if (!c || !body) return;
    var u = currentUser();
    var entries = (c.entries || []).slice().sort(function (a, b) { return (b.votes || 0) - (a.votes || 0); });
    var userVoted = u && c.votes && c.votes[u.email];
    var alreadyEntered = u && entries.some(function (e) { return e.userId === u.email; });
    var pendingDesign = readLS(DESIGN_BRIDGE, null);

    body.innerHTML =
      '<div class="contest-detail">' +
      '  <header class="contest-detail__head">' +
      '    <h2 class="contest-detail__title">' + escHtml(c.title) + '</h2>' +
      '    <p class="contest-detail__desc">' + escHtml(c.description) + '</p>' +
      '    <div class="contest-detail__meta">' +
      '      <span>' + escHtml(fmt(t.detail_prize || '\uD83C\uDF81 {{ prize }}', { prize: c.prize })) + '</span>' +
      '      <span>' + escHtml(fmt(t.detail_deadline || '\u23F0 Ends {{ date }} ({{ left }})', { date: fmtDate(c.deadline), left: timeLeft(c.deadline) })) + '</span>' +
      '      <span>' + escHtml(fmt(t.detail_launcher || '\uD83D\uDC64 Launched by {{ name }}', { name: c.createdBy })) + '</span>' +
      '    </div>' +
      '  </header>' +
      '  <div class="contest-detail__actions">' +
      (alreadyEntered
        ? '<p class="text-soft">' + escHtml(t.entered_already || 'You already entered this contest. \uD83C\uDF89') + '</p>'
        : (pendingDesign
            ? '<button class="btn btn-primary" type="button" id="btnEnterPending">' + escHtml(t.enter_pending || 'Enter with your saved design') + '</button>'
            : '<button class="btn btn-primary" type="button" id="btnCreateEntry">' + escHtml(t.enter_create || 'Create &amp; enter a design') + '</button>')) +
      '  </div>' +
      '  <h3 class="contest-detail__entries-title">' + escHtml(t.leaderboard_title || 'Leaderboard') + '</h3>' +
      '  <div class="contest-entries">' +
      (entries.length ? entries.map(function (e, i) {
        var rank = i === 0 ? '\uD83E\uDD47' : i === 1 ? '\uD83E\uDD48' : i === 2 ? '\uD83E\uDD49' : (i + 1);
        var img = e.imageDataUrl || placeholderFor(i);
        return (
          '<div class="contest-entry card" data-entry="' + escHtml(e.id) + '">' +
          '  <div class="contest-entry__rank">' + rank + '</div>' +
          '  <div class="contest-entry__media">' + (img ? '<img src="' + img + '" alt="' + escHtml(fmt(t.entry_by || 'by {{ name }}', { name: e.authorName })) + '" loading="lazy">' : '<div class="contest-entry__media-empty"></div>') + '</div>' +
          '  <div class="contest-entry__info">' +
          '    <p class="contest-entry__author">' + escHtml(fmt(t.entry_by || 'by {{ name }}', { name: e.authorName })) + '</p>' +
          '    <p class="contest-entry__prompt">\u201C' + escHtml(e.prompt) + '\u201D</p>' +
          '    <div class="contest-entry__foot">' +
          '      <span class="contest-entry__votes">' + escHtml(fmt((e.votes || 0) === 1 ? (t.entry_votes_one || '\u2764\uFE0F {{ count }} vote') : (t.entry_votes_other || '\u2764\uFE0F {{ count }} votes'), { count: e.votes || 0 })) + '</span>' +
          '      <span class="contest-entry__actions">' +
          '        <button type="button" class="btn btn-sage btn-sm" data-make="' + escHtml(e.id) + '">' + escHtml(t.entry_make || 'Make a blanket') + '</button>' +
          '        <button type="button" class="btn btn-outline btn-sm" data-vote="' + escHtml(e.id) + '"' + (userVoted ? ' disabled' : '') + '>' + escHtml(userVoted ? (t.entry_voted || 'Voted \u2713') : (t.entry_vote || 'Vote')) + '</button>' +
          '      </span>' +
          '    </div>' +
          '  </div>' +
          '</div>'
        );
      }).join('') : '<p class="text-soft">' + escHtml(t.entries_empty || 'No entries yet \u2014 be the first!') + '</p>') +
      '  </div>' +
      '</div>';

    // actions
    var enterBtn = el('btnEnterPending') || el('btnCreateEntry');
    if (enterBtn) enterBtn.addEventListener('click', function () { goEnter(c.id); });
    Array.prototype.forEach.call(body.querySelectorAll('[data-vote]'), function (b) {
      b.addEventListener('click', function () { vote(c.id, b.getAttribute('data-vote'), b); });
    });
    Array.prototype.forEach.call(body.querySelectorAll('[data-make]'), function (b) {
      b.addEventListener('click', function () { makeBlanket(c.id, b.getAttribute('data-make')); });
    });
  }

  function showDetail(id) {
    var listSec = el('contestsSection');
    var detailSec = el('contestDetail');
    if (listSec) listSec.hidden = true;
    if (detailSec) detailSec.hidden = false;
    renderDetail(id);
  }

  function showList() {
    var listSec = el('contestsSection');
    var detailSec = el('contestDetail');
    if (listSec) listSec.hidden = false;
    if (detailSec) detailSec.hidden = true;
    renderList();
  }

  /* ---------- launch ---------- */
  function bindLaunch() {
    var btn = el('btnLaunchContest');
    var form = el('launchForm');
    var cancel = el('btnCancelLaunch');
    var t = i18n();
    if (!btn || !form) return;
    btn.addEventListener('click', function () {
      var u = currentUser();
      if (!u) {
        toast(t.launch_signin || 'Please sign in to launch a contest.');
        window.location.href = loginUrl();
        return;
      }
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var dl = el('ctDeadline');
        if (dl) dl.min = new Date().toISOString().slice(0, 10);
      }
    });
    if (cancel) cancel.addEventListener('click', function () { form.hidden = true; });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var u = currentUser();
      if (!u) return;
      var title = (el('ctTitle').value || '').trim();
      var desc = (el('ctDesc').value || '').trim();
      var prize = (el('ctPrize').value || '').trim();
      var deadline = el('ctDeadline').value;
      if (!title || !desc || !prize || !deadline) { toast(t.launch_required || 'Please fill in all fields.'); return; }
      var list = contests();
      list.unshift({
        id: nextId('ct'),
        title: title,
        description: desc,
        prize: prize,
        deadline: new Date(deadline + 'T23:59:59').toISOString(),
        createdBy: u.name || u.email,
        createdAt: new Date().toISOString(),
        entries: [],
        votes: {}
      });
      save(list);
      form.hidden = true;
      form.reset();
      toast(t.launch_success || 'Contest launched! \uD83C\uDF89');
      renderList();
    });
  }

  /* ---------- enter ---------- */
  function goEnter(contestId) {
    var u = currentUser();
    var t = i18n();
    if (!u) { window.location.href = loginUrl(); return; }
    var pending = readLS(DESIGN_BRIDGE, null);
    if (pending && pending.imageDataUrl) {
      addEntry(contestId, pending.imageDataUrl, pending.prompt || 'AI design');
    } else {
      toast(t.enter_ai_first || 'Create a design in AI Studio first \u2014 then come back to enter it!');
      var routes = (global.Lagomlo && global.Lagomlo.routes) || {};
      window.location.href = (routes.root || '/') + 'pages/ai-studio';
    }
  }

  function addEntry(contestId, imageDataUrl, prompt) {
    var u = currentUser();
    var t = i18n();
    var list = contests();
    var c = list.filter(function (x) { return x.id === contestId; })[0];
    if (!c || !u) return;
    if ((c.entries || []).some(function (e) { return e.userId === u.email; })) {
      toast(t.enter_already || 'You already entered this contest.');
      return;
    }
    if (!c.entries) c.entries = [];
    c.entries.push({
      id: nextId('en'),
      userId: u.email,
      authorName: u.name || u.email.split('@')[0],
      prompt: prompt || '',
      imageDataUrl: imageDataUrl,
      votes: 0
    });
    save(list);
    writeLS(DESIGN_BRIDGE, null); // consumed
    toast(t.enter_success || 'Your design is in the contest! \uD83C\uDF89');
    renderDetail(contestId);
  }

  /* ---------- vote ---------- */
  function vote(contestId, entryId, btn) {
    var u = currentUser();
    var t = i18n();
    if (!u) { window.location.href = loginUrl(); return; }
    var list = contests();
    var c = list.filter(function (x) { return x.id === contestId; })[0];
    if (!c) return;
    if (!c.votes) c.votes = {};
    if (c.votes[u.email]) { toast(t.vote_already || 'You already voted in this contest.'); return; }
    c.votes[u.email] = entryId;
    var entry = (c.entries || []).filter(function (e) { return e.id === entryId; })[0];
    if (entry) entry.votes = (entry.votes || 0) + 1;
    save(list);
    toast(t.vote_success || 'Thanks for voting! \u2764\uFE0F');
    renderDetail(contestId);
  }

  /* ---------- make a blanket from an entry ---------- */
  function makeBlanket(contestId, entryId) {
    var t = i18n();
    var c = contests().filter(function (x) { return x.id === contestId; })[0];
    if (!c) return;
    var entry = (c.entries || []).filter(function (e) { return e.id === entryId; })[0];
    if (!entry) return;
    writeLS(DESIGN_BRIDGE, {
      imageDataUrl: entry.imageDataUrl || null,
      prompt: entry.prompt || '',
      style: '',
      from: 'contest'
    });
    toast(t.make_toast || 'Loading this design into the studio\u2026');
    var routes = (global.Lagomlo && global.Lagomlo.routes) || {};
    window.location.href = (routes.root || '/') + 'products/photo-blanket?ai=1';
  }

  /* ---------- init ---------- */
  function init() {
    if (!el('contestGrid') && !el('contestDetailBody')) return;
    var t = i18n();
    seedIfEmpty();
    renderList();
    bindLaunch();
    var back = el('btnBackList');
    if (back) back.addEventListener('click', showList);
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('enter') === '1') {
        // came from AI Studio with a saved design — show contests and hint
        toast(t.enter_hint || 'Now pick a contest to enter your design in!');
      }
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  global.Contests = {
    init: init, renderList: renderList, showDetail: showDetail,
    addEntry: addEntry, vote: vote
  };
})(window);
